export default __webpack_public_path__ + "static/media/English3.4af72faf.png";